module.exports = __webpack_public_path__ + "static/media/start_image.51b1c670.jpg";